import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'handleClick'
        }
    }

    init() {

    }

    handleClick() {
        if(window.SmileUI?.openPanel) {
            window.SmileUI.openPanel();

            this.call('close', null, 'Menu')
        }
    }
}
